import { motion } from "framer-motion";
import { STATS } from "@/lib/landing";

export default function Stats() {
  return (
    <section className="relative z-10 mx-auto max-w-7xl px-5 py-20 sm:px-8">
      <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.08, duration: 0.6 }}
            data-testid={`stat-${i}`}
          >
            <div className="ld-display text-5xl text-[var(--ld-lime)] sm:text-6xl">{s.value}</div>
            <div className="mt-2 text-sm font-semibold leading-snug text-[var(--ld-muted)]">{s.label}</div>
          </motion.div>
        ))}
      </div>
      <p className="mt-12 max-w-2xl text-lg font-semibold text-[var(--ld-text)]/80">
        Driven by real-time weather conditions and official label instructions
        <br />
        <span className="text-[var(--ld-lime)]">delivering precision with zero guesswork.</span>
      </p>
    </section>
  );
}
